/*
 *  Back To Top
 *    Scripts for the back to top button
 *
 *  Version:
 *    1.0.0 - 2022/06/15
 */
import { CLASS_VISIBLE } from "../../tools/constants/classes";

const SELECTOR_BACK_TO_TOP = '[data-back-to-top]';

// When the user scrolls down 300px from the top of the document, show the button
const backToTop = document.querySelector(SELECTOR_BACK_TO_TOP);

const onScroll = () => {
  if (document.body.scrollTop > 300 || document.documentElement.scrollTop > 300) {
    backToTop.classList.add(CLASS_VISIBLE);
  } else {
    backToTop.classList.remove(CLASS_VISIBLE);
  }
}

// When the user clicks on the button, scroll to the top of the document
const onClick = () => {
  document.body.scrollTop = 0; // For Safari
  document.documentElement.scrollTop = 0; // For Chrome, FireFox, IE and Opera
}

window.addEventListener('scroll', onScroll);
backToTop.addEventListener('click', onClick);